import * as React from 'react';

function Lock(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={13} height={15} viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M2.188 6V4.687c0-2.16 1.75-3.937 3.937-3.937 2.16 0 3.938 1.777 3.938 3.938V6h.437c.957 0 1.75.793 1.75 1.75V13c0 .984-.793 1.75-1.75 1.75H1.75C.766 14.75 0 13.984 0 13V7.75C0 6.793.766 6 1.75 6h.438zm1.75 0h4.374V4.687A2.194 2.194 0 006.126 2.5c-1.23 0-2.188.984-2.188 2.188V6z"
        fill="#c19728"
      />
    </svg>
  );
}

export default Lock;
